<template>
<el-dialog
  title=""
  :visible.sync="isLogin"
  width="650px" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="beforeclose">
     <div v-if="type==2 || type==3" class="login">
        <div class="weixin-login-title" style="margin-bottom: 20px;">
          <span>{{type==2?"账号密码登录":"验证码登录"}}</span>
        </div>
        <el-form ref="login" :model="login" size="medium" :rules="loginRules" label-position="left">
          <el-form-item prop="username">
            <el-input
                v-model="login.username"
                type="text"
                :placeholder="type==2?'用户名':'手机号'"
                prefix-icon="el-icon-user"
                autocomplete="off"
                clearable/>
          </el-form-item>
          <el-form-item prop="password" v-if="type==2">
            <el-input
                v-model="login.password"
                type="text"
                placeholder="密码"
                prefix-icon="el-icon-lock"
                @keyup.enter.native="handleLogin"
                autocomplete="off"
                clearable
                show-password/>
          </el-form-item>
          <el-form-item prop="verify" v-if="type==3">
            <div style="position: relative;">
              <el-input
                v-model="login.verify"
                type="text"
                placeholder="请输入验证码"
                prefix-icon="el-icon-user"
                autocomplete="off"
                clearable/>
                <div style="width: 100%;display: flex;">
                  <el-button @click.stop="sendSMS" type="text" style="margin-left: auto;" v-if="countdown==0">
                    <span style="color: rgb(42, 163, 139);">
                      获取验证码
                    </span>
                  </el-button>
                  <el-button  type="text" style="margin-left: auto;" disabled v-if="countdown>0">
                    <span style="color: #aaa;">
                      {{countdown}}s后重新发送
                    </span>
                  </el-button>
                </div>
            </div>
          </el-form-item>
        </el-form>
        <el-button
            :loading="loading"
            size="small"
            type="primary"
            style="width:100%;"
            @click.native.prevent="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <div style="width: 100%;display: flex;align-items: center;color:#666;font-size: 14px;padding-top: 5px;" v-if="type==3">
           首次登录默认密码为：000000
        </div>
        <div style="width: 100%;display: flex;" v-if="type==2">
          <el-button type="text" size="small" style="margin-left: auto;" @click="$refs.forget.show()">
            <span style="color: #2AA38B;">忘记密码</span>
          </el-button>
        </div>
  </div>

  <div class="login-way__title">其他登录方式</div>


  <div class="button-wrapper">
     <div class="button" v-if="type!=2" @click="typeClick(2)">
        <div class="icon icon-phone-login"></div>
        <span>账号密码登录</span>
     </div>
     <!-- <div class="button" v-if="type!=1" @click="typeClick(2)">
        <div class="icon icon-phone-wx"></div>
        <span>微信登录</span>
     </div> -->
     <div class="button" v-if="type!=3" @click="typeClick(3)">
        <div class="icon icon-phone-yzm"></div>
        <span>验证码快捷登录</span>
     </div>
  </div>

  <!--忘记密码-->
  <forgetPassword ref="forget" />
</el-dialog>
</template>

<script>
  import {mapGetters} from "vuex"
  import { sendSms,loginCode } from "@/api/gw/login.js"
  import { isMobile } from "@/utils/rules.js"
  import forgetPassword from "./forgetPassword.vue"
  export default {
    components:{
      forgetPassword
		},
    computed:{
      ...mapGetters(['isLogin']),
    },
    data(){
      return{
        loading:false,
				timer:null,
        countdown:0,//倒计时的秒数

        type:3,//1微信登录  2账号+密码登录 3验证码登录
        login:{
          username:"",
          password:"",
          verify_id:"",//短信验证码ID
          verify:"",//短信验证码
        },
        loginRules: {
        username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
        verify: [{required: true, message: '请输入验证码', trigger: 'blur'}]
      },
      }
    },
    watch:{
      isLogin(e){
        if(e==false){
          this.loading = false
          if(this.timer){
             this.countdown = 0
             clearInterval(this.timer);
          }
        }
      },
    },
    mounted(){
      // this.$store.dispatch("set_isLogin",true)
    },
    methods: {
      //发送验证码
      sendSMS(){
         if(!this.login.username){
           this.$message.error("请输入手机号");
           return;
         }
         const loading = this.$loading({
               lock: true,
               text: '发送中',
               spinner: 'el-icon-loading',
               background: 'rgba(0, 0, 0, 0.7)'
             });
          sendSms({
            mobile:this.login.username
          }).then(res=>{
            console.log("发送成功",res);
            this.login.verify_id = res.key
            this.countdown = 60
            this.timer = setInterval(()=>{
              if(this.countdown<=0){
                this.countdown = 0
                clearInterval(this.timer)
              }else{
                this.countdown--;
              }
            },1000)
          }).finally(()=>{
            loading.close();
          })
      },
      beforeclose(){
        this.$store.dispatch("set_isLogin",false)
      },
      typeClick(type){
          this.type = type
      },
      //登录
      handleLogin() {
      this.$refs['login'].validate(valid => {
        if (valid) {
          // console.log('表单验证成功')
          this.loading = true
          let scene = this.$cookies.get("share_pid");
          if(this.type==2){
            this.$store.dispatch("login",{
                username:this.login.username,
                password:this.login.password,
                scene:scene
              }).then(res=>{
              //登录成功以后获取个人信息
      console.log("login2")
              this.$store.dispatch("set_isLogin",false);
              this.$store.dispatch("getUserInfo");
              //刷新
              window.location.reload();
            }).catch(err=>{
              this.loading = false
            })
          }else{
            this.$store.dispatch("loginCode",{
              phone:this.login.username,
              mobile:this.login.username,
              verify_id:this.login.verify_id,
              verify:this.login.verify,
              scene:scene
            }).then(res=>{
              debugger;
              //登录成功以后获取个人信息
      console.log("login3")
              this.$store.dispatch("set_isLogin",false);
              this.$store.dispatch("getUserInfo");
              window.location.reload();
            }).catch(err=>{
              this.loading = false
            })
          }
          // this.$store.dispatch('login', this.login).then(res => {
          //   this.$router.push(this.success_url)
          //   this.loading = false
          // }).catch(err => {
          //   this.loading = false
          //   this.captche()
          // })
        }
      })
    }
    }
  }
</script>

<style lang="scss" scoped>
::v-deep .el-button--primary{
  background: #2AA38B!important;
  border: 1px solid #2AA38B;
}
.button-wrapper{
  margin: 0 auto!important;
    display: flex;

    justify-content: center;
    width: 80%;
    .button{
      display: flex;
    align-items: center;
    cursor: pointer;
    .icon{
      width: 20px;
    height: 20px;
    margin-right: 14px;
    }
    .icon-phone-login{
      background: url("../assets/phone-bg.svg") 0 0/ 100% auto;
    }
    .icon-phone-wx{
      background: url("../assets/wx.png") 0 0/ 100% auto;
    }
    .icon-phone-yzm{
      background: url("../assets/yzm.png") 0 0/ 100% auto;
    }
    }
}
.login-way__title{
    margin: 0 auto;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 21px;
    padding: 0 30px;
    color: rgba(0,0,0,0.25);
    background: url("../assets/divider1.png") no-repeat center center/ 85% auto;
}
.login{
		width: 300px;
		margin: 0 auto;
		// margin-top: 10px;
		padding-bottom: 30px;
		.weixin-login-tips{
			    font-size: 14px;
			    color: rgba(0,0,0,.8);
				width: 100%;
				margin-top: 20px;
				text-align: center;
		}
		.qrcode-wrapper{
			width: 204px;
			height: 204px;
			background: #fff;
			// border: 1px solid #eee;
			border-radius: 6px;
			margin: 24px auto;
			display: flex;
			align-items: center;
			justify-content: center;
			.qrcode-container{
				position: relative;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				img{
					width: 250px;
					height: 250px;
				}
			}
		}
		.weixin-login-title{
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 32px;
			color: rgba(0,0,0,.8);
			width: 100%;
			i{
				display: inline-block;
				width: 26px;
				height: 26px;
				background-image: url(../assets/svg/logreg_sprite.svg);
				background-position: -29px -28px;
				margin-right: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue